module.exports = __webpack_public_path__ + "img/gallery_more.74abeedb.svg";